import { render } from "./InventoryDashboardPage.vue?vue&type=template&id=188dec12"
import script from "./InventoryDashboardPage.vue?vue&type=script&lang=js"
export * from "./InventoryDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__